<template>
	<div class="active-accounts">
		<h2>
			{{ $t('onboarding_accountpicker_chooseaccount', [contact]) }}
		</h2>
		<div class="account-container">
			<div
				class="account-row"
				v-for="account in accounts"
				:key="account.user.id"
			>
				<BasicUserPill
					:profile="account.user.organization"
					:mainText="account.user.organization.name"
					:subText="account.user.firstname + ' ' + account.user.lastname"
					@click="onClick(account)"
				/>
				<Button
					pronto
					@click="onClick(account)"
					:aria-label="
						$t('onboarding_login_launch_alt_text', {
							orgName: account.user.organization.name,
							userName: account.userfirstname + ' ' + account.user.lastname,
						})
					"
					:loading="loadingAccountId === account.user.id"
				>
					{{ $t('onboarding_splash_signin') }}
				</Button>
			</div>
		</div>
	</div>
</template>

<script>
import { setDesktopLoginUrls } from '@/helperMethods'
import { BasicUserPill, Button } from '../common'

export default {
	name: 'LoginAccounts',
	components: { BasicUserPill, Button },
	props: ['accounts', 'contact'],
	data() {
		return { loadingAccountId: null }
	},
	emits: ['account'],
	mounted() {
		setDesktopLoginUrls(this.accounts)
	},
	watch: {
		accounts: {
			handler() {
				setDesktopLoginUrls(this.accounts)
			},
			deep: true,
		},
	},
	methods: {
		onClick(account) {
			this.loadingAccountId = account.user.id
			this.$emit('account', account)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.active-accounts {
	@include flex-column-center;
	width: 100%;
}
.account-container {
	width: 100%;
	.account-row {
		@include flex-spread;
		cursor: pointer;
		padding: 16px 0;
		border-bottom: 1px solid var(--neutral-200);
		&:last-child {
			border-bottom: 0;
		}
	}
}

:deep(.user-pill) {
	min-width: calc(100% - 145px);
}
</style>
